import type { FC } from 'react';

import type { AssetsShareUserSchemaWithId } from '@iconik-io/iconik-api/src/services/assets';
import { OBJECT_TYPE_SHARE_USERS } from '@iconik-io/iconik-api/src/types/object_types';

import { deleteShareUsers } from '../../../ducks/shares_users/thunks';
import { useAppDispatch } from '../../../store/react_redux_typed';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';
import DeleteObjectsModal from './delete_objects';

type Props = ModalComponentProps &
  ContextItemsHocProps<AssetsShareUserSchemaWithId>;

const DeleteShareUsersModal: FC<Props> = (props) => {
  const dispatch = useAppDispatch();
  return (
    <DeleteObjectsModal
      modalId={props.modalId}
      isOpen={props.isOpen}
      onCancel={props.onCancel}
      onConfirm={props.onConfirm}
      objectType={OBJECT_TYPE_SHARE_USERS}
      deleteEntityByIds={() => dispatch(deleteShareUsers(props.items))}
    />
  );
};

export default withContextItems(DeleteShareUsersModal);
